import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import UserView from './pages/user/View'
import Lead from './pages/Lead/Lead';
import DashboardAppPage from './pages/DashboardAppPage';
import LeadView from './pages/Lead/View'
import Contact from './pages/contact/Contact';
import ContactView from './pages/contact/View'
import Policy from './pages/policy/Policy'
import PolicyView from './pages/policy/View'
import Calendar from './pages/Calendar/Calendar';
import Document from './pages/documents/Documents';
import Calls from './pages/calls/Call';
import CallsView from './pages/calls/View'
import Meeting from './pages/meeting/Meeting';
import MeetingView from './pages/meeting/View'
import Email from './pages/email/Email'
import EmailView from './pages/email/View'
import Task from './pages/task/Task';
import TaskView from './pages/task/View'
import Sms from './pages/sms/Sms';
import SmsView from './pages/sms/View';
import EmailTemplate from './pages/emailTemplate/EmailTemplate';
import AddEmailTemplate from './pages/emailTemplate/Add'
import ViewEmailTemplate from './pages/emailTemplate/View'
import ImportView from './components/Import/ImportView';
import Payment from './pages/Payment/Payment';
import PaymentView from './pages/Payment/View';
import SMSTemplate from './pages/smsTemplate/SMSTemplate';
import ViewSMSTemplate from './pages/smsTemplate/View';
import Page404 from './pages/Page404';
import ChangePassword from './pages/user/ChangePassword';
import ContactMessage from './pages/whatsapp/contacts/ContactMessages';
import Contacts from './pages/whatsapp/contacts/Contacts';
import Conversations from './pages/whatsapp/Conversations';
import DmvicCertificates from './components/dmvic/DmvicCertificates';
import Certificates from './pages/Dmvic/certificates';
import ViewCertficate from './components/dmvic/viewCertficate';
import GenerateQuotation from './components/quotation/generate';
import ViewUnderwriterPremiums from './components/underwriters/premiums/show';
import ViewUnderwriters from './components/underwriters/show';
import ViewInvoices from './pages/Krainvoicing/View';
import Invoices from './pages/Krainvoicing/Invoices';
// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'user/view/:id', element: <UserView /> },
        { path: 'user/changepassword', element: <ChangePassword /> },
        { path: 'lead', element: <Lead /> },
        { path: 'lead/view/:id', element: <LeadView /> },
        { path: 'contact', element: <Contact /> },
        { path: 'contact/view/:id', element: <ContactView /> },
        { path: 'policy', element: <Policy /> },
        { path: 'policy/view/:id', element: <PolicyView /> },
        { path: 'calendar', element: <Calendar /> },
        { path: 'document', element: <Document /> },

        { path: 'call', element: <Calls /> },
        { path: 'call/view/:id', element: <CallsView /> },
        { path: 'meeting', element: <Meeting /> },
        { path: 'meeting/view/:id', element: <MeetingView /> },
        { path: 'email', element: <Email /> },
        { path: 'email/view/:id', element: <EmailView /> },
        { path: 'task', element: <Task /> },
        { path: 'task/view/:id', element: <TaskView /> },
        { path: 'sms', element: <Sms /> },
        { path: 'sms/view/:id', element: <SmsView /> },
        { path: 'emailtemplate', element: <EmailTemplate /> },
        { path: 'emailtemplate/add', element: <AddEmailTemplate /> },
        { path: 'emailtemplate/view/:id', element: <ViewEmailTemplate /> },
        { path: ':view/import', element: <ImportView /> },
        { path: 'payment', element: <Payment /> },
        { path: 'payment/view/:id', element: <PaymentView /> },
        { path: 'smstemplate', element: <SMSTemplate /> },
        { path: 'smstemplate/view/:id', element: <ViewSMSTemplate /> },
        { path: 'whatsapp/contacts', element: <Contacts /> },
        { path: 'whatsapp/conversations', element: <Conversations /> },
        { path: 'whatsapp/contacts/:id', element: <ContactMessage /> },
        { path: 'dmvicpayment/view/:id', element: <DmvicCertificates /> },
        { path: 'certificates', element: <Certificates /> },
        { path: 'certificate/view/:id', element: <ViewCertficate /> },
        { path: 'quotation', element: <GenerateQuotation /> },
        { path: 'underwriters', element: <ViewUnderwriters /> },
        { path: 'underwriterpremiums/view/:id', element: <ViewUnderwriterPremiums /> },
        { path: 'krainvoices', element: <Invoices /> },
        { path: 'krainvoices/view/:id', element: <ViewInvoices /> },
        { path: '*', element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
      ],
    },

    {
      element: <SimpleLayout />,
      children: [
        { path: '*', element: <Navigate to="/dashboard/app" />, index: true },
        // { path: '404', element: <Page404 /> },
      ],
    },
    // {
    //   path: '*',
    //   element: <Navigate to="/404" replace />,
    // },
  ]);

  return routes;
}
